import { ApiPath } from "enums";
import { Get } from "utils";

const axiosEncode = (val) =>
  encodeURIComponent(val)
    .replace(/%3A/gi, ":")
    .replace(/%24/g, "$")
    .replace(/%2C/gi, ",")
    .replace(/%20/g, "+")
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]");

const paramsSerializer = (params) => {
  const parts = [];
  Object.entries(params || {}).forEach(([key, rawVal]) => {
    if (rawVal === null || rawVal === undefined) return;
    const isArray = Array.isArray(rawVal);
    const listKey = isArray ? `${key}[]` : key;
    const values = isArray ? rawVal : [rawVal];
    values.forEach((v) => {
      let value = v;
      if (value instanceof Date) value = value.toISOString();
      else if (value !== null && typeof value === "object") value = JSON.stringify(value);
      const encodedValue = key === "searchKey" ? encodeURIComponent(value) : axiosEncode(value);
      parts.push(`${axiosEncode(listKey)}=${encodedValue}`);
    });
  });
  return parts.join("&");
};

export const getTransactionItemsDiscountByStation = async (query) => {
  const res = await Get(`${ApiPath.Transaction}/${query?.stationCode}/item/discount`, query, {
    paramsSerializer,
  });
  return res.data;
};
